var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile" },
    [
      _vm.loading
        ? _c("c-loader", {
            attrs: { active: true, height: 450, label: "Анкета загружается" },
          })
        : [
            _vm.profile
              ? _c("profile-view", {
                  attrs: {
                    "user-id": _vm.userId,
                    profile: _vm.profile,
                    "profile-data": _vm.profileData,
                    editable: _vm.editable,
                  },
                })
              : _vm.positions
              ? _c("positions-view", {
                  attrs: { positions: _vm.positions },
                  on: { update: _vm.getData },
                })
              : _c(
                  "div",
                  { staticClass: "no-profile" },
                  [
                    _c("div", { staticClass: "mb-4 text" }, [
                      _vm._v("Анкеты для этой должности еще не создано"),
                    ]),
                    _c("c-button", {
                      attrs: { color: "primary", label: "Новая анкета" },
                      on: { click: _vm.createProfile },
                    }),
                  ],
                  1
                ),
          ],
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }